import { translateStatus } from './DriverPopup.utils';

interface StatusIndicatorProps {
  status?: string;
}

export const StatusIndicator = ({ status }: StatusIndicatorProps) => {
  if (!status) return null;

  return (
    <div className='flex items-center gap-1.5'>
      <div className='w-2 h-2 bg-green-500 rounded-full'></div>
      <p className='text-xs font-medium text-gray-600'>
        {translateStatus(status)}
      </p>
    </div>
  );
};
